import {getQuery, isEmpty, isNotEmpty} from "../../tools/utils";
import API from '@/apis/index';

let defaultItem =  {label: '',name: '',value: '',type: 'input',isDiy:true,required:true,labelWidth:120, showlabel: true, filled:false, outlined: true, disable:false, minWidth: 160};

const formSetItem = [
    {label: '特价单号',name: 'VBELN',value: '',labelWidth:120, showlabel: true,type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
    {label: 'SC电子订单号',name: 'F_cn_FBILLNO',value: '',labelWidth:120, showlabel: true,type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
    {label: '特折号',name: 'BSTKD',value: '',labelWidth:120, showlabel: true,type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
    // {label: '特价客户',name: '',value: '',labelWidth:120, showlabel: true,type: 'input', filled:false, outlined: true, disable:false,required:true,minWidth: 160},
    // {label: '供应商名称',name: '',value: '',labelWidth:120, showlabel: true,type: 'input', filled:false, outlined: true, disable:false,required:false,minWidth: 160},
    {label: '订货人',name: 'KUNNR',value: '',labelWidth:120, showlabel: true,type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
    {label: '收货人',name: 'KGNNR',value: '',labelWidth:120, showlabel: true,type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
    {label: '收货人地址名称1',name: 'NAME1',value: '',labelWidth:120, showlabel: true,type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
    {label: '收货人地址名称2',name: 'NAME2',value: '',labelWidth:120, showlabel: true,type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
    {label: '收货人邮政编码',name: 'POSTL_COD1',value: '',labelWidth:120, showlabel: true,type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
    {label: '收货人城市',name: 'CITY1',value: '',labelWidth:120, showlabel: true,type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
    {label: '三方协议号',name: 'ZZPROM',value: '',labelWidth:120, showlabel: true,type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
    {label: '销售组织',name: 'VKORG',value: '',labelWidth:120, showlabel: true,type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
    {label: '销售渠道',name: 'VTWEG',value: '',labelWidth:120, showlabel: true,type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
    {label: '销售产品组',name: 'SPART',value: '',labelWidth:120, showlabel: true,type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
    {label: '创建人',name: 'ERNAM',value: '',labelWidth:120, showlabel: true,type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
    {label: '货币单位',name: 'WAERK',value: '',labelWidth:120, showlabel: true,type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
    {label: '预付款标志',name: 'DPFLAG',value: '',labelWidth:120, showlabel: true,type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
    {label: '采购订单号',name: 'BSTKD_E',value: '',labelWidth:120, showlabel: true,type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
    {label: '客户采购订单创建日期',name: 'BSTDK',value: '',labelWidth:120, showlabel: true,type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
    {label: '报价日期',name: 'ERDAT',value: '',labelWidth:120, showlabel: true,type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
]
const formSet = {
    formSet: {form_class: 'base_form',  body: [
            {index: 1, body_class: 'q-gutter-sm row items-start',
                items:JSON.parse(JSON.stringify(formSetItem))
            },
        ]},
    formSet2: {form_class: 'base_form',  body: [
            {index: 1, body_class: 'q-gutter-sm row items-start',
                items:[
                    {index: 1, label: '整单不含税金额 ',name: 'NETWRH',value: '',labelWidth:120, showlabel: true,type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
                    {index: 1, label: '整单税额 ',name: 'MWSTH',value: '',labelWidth:120, showlabel: true,type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
                    {index: 1, label: '合计金额 ',name: '',value: '',labelWidth:120, showlabel: true,type: 'input', filled:false, outlined: true, disable:true, minWidth: 160},
                ]
            },
        ]},
};
let cacheSize = parseInt(localStorage.getItem('pageSize'))
const baseData = {
    baseData:{
        company: {selected: '', data: []}, //公司
        payment: {selected: '', data: []}, //付款方式
        address: {selected: '', data: []}, // 收货地址
        branch: {selected: '', data: []}, // 行业
        country: {selected: '', data: []}, // 行业
        form: {},
        showQuery: true,
    }
};
const tableSet = {
    tableSet:{
        table_class: 'layout-table',
        dense: true,
        edit: false,
        row_key:'FEntryId',
        isFullscreen:false,
        hidePagination: true,
        isSelect:true,
        selected: [],
        selection: 'none',
        separator: 'cell', //表格边框
        data:[],
        signCol:['qty'],
        columns: [
            {name: 'POSNR',field: 'POSNR',label: '行号',type:'input',edit:false,check: true,required: true, headerStyle: 'min-width: 60px',align: 'left'},
            {name: 'MATNR',field: 'MATNR',label: '订货号',type:'inputSelect',edit:false,check: true,required: true, headerStyle: 'min-width: 60px',align: 'left'},
            {name: 'KWMENG',field: 'KWMENG',label: '数量',isAddCol:true,type:'number',edit:false,check: true,required: true, headerStyle: 'min-width: 60px',align: 'right'},
            {name: 'qty',field: 'qty',label: '匹配数量',isAddCol:true,type:'number',edit:false,check: true,required: true, headerStyle: 'min-width: 60px',align: 'right'},
        ],
        visibleColumns: [],
        tools: {
            isShow:false,
            active_index: 1,
        }
    },
    tableSet2:{
        table_class: 'layout-table',
        signCol:['qty'],
        dense: true,
        edit: false,
        row_key:'rowNo',
        isFullscreen:false,
        hidePagination: true,
        isSelect:true,
        selected: [],
        selection: 'multiple',
        separator: 'cell', //表格边框
        data:[],
        columns: [
            {name: 'FPRBILLNO',field: 'FPRBILLNO',label: '采购申请单号',check: true,required: true,width:60,headerStyle: 'min-width: 60px',align: 'left'},
            {name: 'FEntryID',field: 'FEntryID',label: '行号',check: true,required: true, headerStyle: 'min-width: 60px',align: 'left'},
            {name: 'MATNR',field: 'MATNR',label: '订货号',type:'inputSelect',edit:false,check: true,required: true, headerStyle: 'min-width: 60px',align: 'left'},
            {name: 'FQTY',field: 'FQTY',label: '数量',type:'number',isAddCol:true,edit:false,check: true,required: true, headerStyle: 'min-width: 60px',align: 'right'},
            {name: 'qty',field: 'qty',label: '匹配数量',isAddCol:true,type:'number',edit:false,check: true,required: true, headerStyle: 'min-width: 60px',align: 'right'},
            {name: 'sono',field: 'sono',label: '特价单号',type:'inputSelect',edit:false,check: true,required: true, headerStyle: 'min-width: 60px',align: 'left'},
            {name: 'so_lineid',field: 'so_lineid',label: '行号',type:'inputSelect',edit:false,check: true,required: true, headerStyle: 'min-width: 60px',align: 'left'},
            {name: 'KUNWE',field: 'KUNWE',label: '收获地址',type:'input',edit:true,check: true,required: true, headerStyle: 'min-width: 60px',align: 'right'},
            {name: 'EDATU',field: 'EDATU',label: '交货日期',type:'date',edit:true,check: true,required: true, headerStyle: 'min-width: 60px',align: 'right'},
        ],
        visibleColumns: [],
        tools: {
            isShow:false,
            active_index: 1,
            buttons: [
                {
                    sign: 'add',
                    index: 1,
                    label: '匹配',
                    icon: 'fas fa-plus'
                },{
                    sign: 'add',
                    index: 1,
                    label: '提交',
                    icon: 'fas fa-plus'
                }
            ]
        }
    },
    purchaseTableSet:{
        row_key:'FPRBILLNO',
        table_class: 'layout-table',
        height:'',
        dense: true,
        edit: false,
        isFullscreen:false,
        hidePagination: false,
        selected: [],
        selection: 'multiple',
        maxHeight: '',
        separator: 'cell', //表格边框
        pagination: { rowsPerPage: cacheSize?cacheSize:30, rowsNumber: 2, page: 1, search: '' },
        data:[],
        columns: [
            {name: 'FPRBILLNO',field: 'FPRBILLNO',label: '采购单号',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'FDate',field: 'FDate',label: '采购日期',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
        ],
        visibleColumns: [],
        tools: {
            isShow:false,
            active_index: 1,
        }
    },
}
const state = () => ({
    eorderDetails: Object.assign({}, formSet,baseData,tableSet)
})
const getters = {
    getFormSet: state => state.eorderDetails.formSet,
    getFormSet2: state => state.eorderDetails.formSet2,
    getBaseData :state => state.eorderDetails.baseData,
    getTableSet:state => state.eorderDetails.tableSet,
    getTableSet2:state => state.eorderDetails.tableSet2,
    gePurchaseTableSet:state => state.eorderDetails.purchaseTableSet,
}
const mutations = {
    ['refreshTableHeight'](state, data) {
        state.eorderDetails.tableSet.height = data + 'px';
        state.eorderDetails.tableSet2.height = data + 'px';
    },
    ['clearData'](state,data){
        state.eorderDetails.formSet.billObj = {};
        state.eorderDetails.formSet2.billObj = {};
        state.eorderDetails.tableSet.data = [];
        state.eorderDetails.tableSet2.data = [];
        state.eorderDetails.purchaseTableSet.data = [];
        state.eorderDetails.formSet.body[0].items.forEach(item=>{
            item.value = '';
        });
        state.eorderDetails.formSet2.body[0].items.forEach(item=>{
            item.value = '';
        });
    },
    ['setData'](state,data){
        if(isNotEmpty(data?.result?.data?.customer_fields)){
            let addFiled = [];
            let fields = data?.result?.data?.customer_fields;
            Object.keys(fields).forEach((key,index)=>{
                let fromItem = JSON.parse(JSON.stringify(defaultItem));
                fromItem.name = key;
                fromItem.label = fields[key].label;
                fromItem.required = isNotEmpty(fields[key].required) ? fields[key].required : false;
                if(isNotEmpty(fields[key].options)){
                    fromItem.type = 'select';
                    fromItem.variant = {
                        options:[]
                    }
                    fields[key].options.forEach(opItem=>{
                        let keys = Object.keys(opItem);
                        fromItem.variant.options.push({label:keys[0],value:opItem[keys[0]]});
                    })
                }
                addFiled.push(fromItem);
            });
            state.eorderDetails.formSet.body[0].items = [...addFiled,...JSON.parse(JSON.stringify(formSetItem))];
        }
        state.eorderDetails.tableSet2.selected = [];
        state.eorderDetails.tableSet.data = data.result.data.match_so;
        data.result.data.match_po.forEach((item,index)=>{
            item.rowNo = index;
        });
        state.eorderDetails.tableSet2.data = data.result.data.match_po;
        state.eorderDetails.formSet.body[0].items.forEach(item=>{
            if(isNotEmpty(data.result.data[item.name])){
                item.value = data.result.data[item.name];
            }else if(!item.isDiy){
                item.value = '';
            }
        });
        state.eorderDetails.formSet2.body[0].items.forEach(item=>{
            if(isNotEmpty(data.result.data[item.name])){
                item.value = data.result.data[item.name];
            }else{
                item.value = '';
            }
        });
        
        // 计算合计金额 = 整单不含税金额 + 整单税额
        let netAmount = parseFloat(data.result.data.NETWRH) || 0;
        let taxAmount = parseFloat(data.result.data.MWSTH) || 0;
        let totalAmount = netAmount + taxAmount;
        
        // 设置合计金额到第三个表单项
        if(state.eorderDetails.formSet2.body[0].items.length >= 3) {
            state.eorderDetails.formSet2.body[0].items[2].value = totalAmount.toFixed(2);
        }
    },
    ['setTableHeight'](state, data){
        state.eorderDetails.purchaseTableSet.height = (data-120) + 'px';
    },
    ['clearList'](state, data) {
        state.eorderDetails.purchaseTableSet.data = []
        state.eorderDetails.purchaseTableSet.pagination.count = 0;
    },
    ['setList'](state, data) {
        state.eorderDetails.purchaseTableSet.data = data.data.data;
        state.eorderDetails.purchaseTableSet.pagination.count = data.data.count;
    },
    ['removePOData'](state, data) {
        state.eorderDetails.tableSet2.data  = state.eorderDetails.tableSet2.data.filter(item=>{
            return !data.includes(item.rowNo)
        });
    },
    ['setLoading'](state, data) {
        state.eorderDetails.formSet.loading = data;
        state.eorderDetails.formSet2.loading = data;
        state.eorderDetails.tableSet.loading = data;
        state.eorderDetails.tableSet2.loading = data;
    },
};
const actions = {
    ['make_order_return']({state,commit,rootGetters,dispatch},payload){
        commit('setLoading',false);
        if(payload.result.success){
            commit('setList',payload.result);
            dispatch('response/success-tip', { message: '生成订单成功！' }, { root: true });
        }else{
            if(payload?.result?.msg){
                dispatch("response/set-api-response", {errorMessage:payload?.result?.msg}, { root: true })
            }
        }
    },
    ['makeOrder']({state,commit,rootGetters,dispatch},data){
        if(state.eorderDetails.formSet.loading) return
        let msg = {
            event: "command",
            data: {
                run: "make_order",  //需要获取的数据方法
                query: data            //筛选查询条件
            }
        };
        dispatch('channel/socket_send', msg, { root: true })
        commit('setLoading',true);
    },
    ['makeDry']({state,commit,rootGetters,dispatch},data){
        if(state.eorderDetails.formSet.loading) return
        let msg = {
            event: "command",
            data: {
                run: "make_dry",  //需要获取的数据方法
                query: data            //筛选查询条件
            }
        };
        dispatch('channel/socket_send', msg, { root: true })
        commit('setLoading',true);
    },
    ['getEorderDetails']({state,commit,rootGetters,dispatch},data){
        if(state.eorderDetails.formSet.loading) return
        commit('clearData');
        let msg = {
            event: "command",
            data: {
                run: "make_source",  //需要获取的数据方法
                query: {
                    sprno:data.id
                }             //筛选查询条件
            }
        };
        dispatch('channel/socket_send', msg, { root: true })
        commit('setLoading',true);
    },
    ['setData']({state,commit,rootGetters,dispatch},data){
        commit('setLoading',false);
        if(data.result.success){
            commit('setData',data);
        }else{
            if(data?.result?.msg){
                dispatch("response/set-api-response", {errorMessage:data?.result?.msg}, { root: true })
            }
        }
    },


    ['getList']({ state, commit ,dispatch},payload) {
        if (state.eorderDetails.purchaseTableSet.loading == true) return;
        commit('clearList');
        let msg = {
            event: "command",
            data: {
                run: "purchase_picker",  //需要获取的数据方法
                query: payload             //筛选查询条件
            }
        };
        dispatch('channel/socket_send', msg, { root: true })
        state.eorderDetails.purchaseTableSet.loading = true
    },
    ['setList']({ state, commit ,dispatch},payload) {
        state.eorderDetails.purchaseTableSet.loading = false;
        if(payload.result.success){
            commit('setList',payload.result);
        }else{
            if(payload?.result?.msg){
                dispatch("response/set-api-response", {errorMessage:payload?.result?.msg}, { root: true })
            }
        }
    },
};
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
